import {environment as environmentMain} from 'src/environments/environment';
import {ModulTozsamosciService} from "../services/modul-tozsamosci-service/modul-tozsamosci.service";
import {isDevMode} from "@angular/core";
import {AuthConfig, NullValidationHandler} from "angular-oauth2-oidc";
import {CookieStorage} from "cookie-storage";

export function initializeModulTozsamosci(mtService: ModulTozsamosciService): () => Promise<any> {
  return (): Promise<boolean> => {
    const cookieStorage = new CookieStorage({
      path: '/',
      secure: false,
      sameSite: 'Strict'
    });
    const authConfig: AuthConfig = {
      issuer: environmentMain.mt.config.issuer + 'auth/realms/' + environmentMain.mt.config.realm,
      redirectUri: environmentMain.mt.config.redirectUri,
      postLogoutRedirectUri: isDevMode() ? null : environmentMain.mt.config.postLogoutRedirectUri,
      clientId: environmentMain.mt.config.clientId,
      scope: environmentMain.mt.config.scope,
      responseType: environmentMain.mt.config.responseType,
      disableAtHashCheck: true,
      showDebugInformation: true,
      requireHttps: false,
      tokenEndpoint: environmentMain.mt.config.issuer + 'auth/realms/' + environmentMain.mt.config.realm
    };
    mtService.configure(authConfig);
    mtService.setStorage(cookieStorage);
    mtService.tokenValidationHandler = new NullValidationHandler();
    return mtService.loadDiscoveryDocumentAndTryLogin();
  };
}
